import * as React from 'react'
import { Theme, useTheme } from '@mui/material/styles'
import { FC, useCallback } from 'react'
import { SoldServiceStatus } from './SoldServicesStatus'
import { soldServiceBackgroundColor } from './utils/soldServiceBackgroundColor'
import { SoldServicesBannerDetails } from './SoldServicesBannerDetails'
import { soldServiceStatusColor } from './SoldServicesCardFooter/soldServiceStatusColor'
import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import Box from '@mui/material/Box'

import { useNavigate } from 'react-router-dom'
import { darken } from '@mui/material/styles'

interface Props {
  details?: React.Component
  onReOpenClick: () => void
  opportunityId: number
  soldServiceStatus: SOLD_SERVICE_STATUS
}

const getStyles = (props: Props) => ({
  root: {
    backgroundColor: soldServiceBackgroundColor(props.soldServiceStatus),
    borderRadius: 0.4,
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'row no-wrap',
    fontSize: '14px',
    padding: (theme: Theme) => `${theme.spacing(1.2)} ${theme.spacing(1.2)}`,
  },
})

export const SoldServicesBanner: FC<Props> = (props) => {
  const { opportunityId } = props
  const theme = useTheme()
  const textColor = darken(
    soldServiceStatusColor(props.soldServiceStatus, theme),
    0.6,
  )

  const navigate = useNavigate()

  const onNewOpportunityClick = useCallback(
    () =>
      navigate(
        `/opportunities/addOpportunity?source=opportunity&id=${opportunityId}`,
      ),
    [navigate, opportunityId],
  )
  const styles = getStyles(props)

  return (
    <>
      <Box sx={styles.root}>
        <SoldServiceStatus
          {...props}
          textColor={textColor}
          details={
            <SoldServicesBannerDetails
              {...props}
              textColor={textColor}
              onNewOpportunityClick={onNewOpportunityClick}
            />
          }
        />
      </Box>
    </>
  )
}
SoldServicesBanner.displayName = 'SoldServicesBanner'
